<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useMainStore } from '~/stores/mainStore';

interface Props {
  show: boolean;
}

const props = defineProps<Props>();

const store = useMainStore();
const bannerText = computed(() => store.siteSettings?.twoFactorAuthBannerText);

function goToSetup() {
  navigateTo('/account/personal/two-factor');
}
</script>

<template>
  <div v-if="props.show" class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
    <div class="flex items-center justify-between">
      <div class="flex items-start">
        <FontAwesomeIcon :icon="['fas', 'shield-halved']" class="text-yellow-400 mt-1 mr-3" />
          <div class="flex-1">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-if="bannerText" class="text-sm text-yellow-800 [&_p]:mb-2 [&_p:last-child]:mb-0 [&_strong]:font-semibold [&_b]:font-semibold" v-html="bannerText"></div>
            <div v-else>
            <h3 class="text-sm font-bold text-yellow-800 mb-2">
              IMPORTANT - Two-Factor Authentication will be MANDATORY from Monday 20th April 2026.
            </h3>
            <div class="text-sm text-yellow-800 space-y-1">
              <p>
                All logins to UniHomes must be protected by 2FA from this date. Please set it up ASAP to ensure uninterrupted service.
              </p>
              <p class="text-xs pt-1">
                We strongly advise NOT to share usernames & passwords. If your login details are shared with others, please see <a href="https://docs.agents.unihomes.co.uk/how-to-guides/how-to-add-a-new-user" target="_blank" rel="noopener noreferrer" class="underline font-semibold hover:text-yellow-900 transition-colors">How to Add a New User</a>
              </p>
            </div>
          </div>
          <div class="mt-3 flex space-x-2">
            <UhButton
              size="sm"
              @click="goToSetup"
            >
              Set Up Now
            </UhButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
